import React, { useEffect, useState, useRef } from 'react';
import { useLanguage, Language } from '../context/LanguageContext';
import { ChevronDown } from 'lucide-react';
const languages: {
  code: Language;
  label: string;
  flag: string;
}[] = [{
  code: 'es',
  label: 'Español',
  flag: '🇪🇸'
}, {
  code: 'en',
  label: 'English',
  flag: '🇬🇧'
}, {
  code: 'fr',
  label: 'Français',
  flag: '🇫🇷'
}, {
  code: 'pl',
  label: 'Polski',
  flag: '🇵🇱'
}, {
  code: 'de',
  label: 'Deutsch',
  flag: '🇩🇪'
}];
export const LanguageSwitcher = () => {
  const {
    language,
    setLanguage
  } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const currentLang = languages.find(l => l.code === language) || languages[0];
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  return <div className="relative" ref={dropdownRef} data-id="element-420" data-mp="23laeliwyu0ie">
      <button onClick={() => setIsOpen(!isOpen)} className="flex items-center space-x-2 bg-white/10 hover:bg-white/20 transition-colors px-3 py-2 rounded-lg text-white text-sm font-medium" data-id="element-421" data-mp="23o6cj78tcp6u">
        <span data-id="element-422" data-mp="2wckefy30w5no">{currentLang.flag}</span>
        <span className="uppercase" data-id="element-423" data-mp="2rbek5vtpsac1">{currentLang.code}</span>
        <ChevronDown className={`w-4 h-4 transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-424" data-mp="2mky403yiealz" />
      </button>

      {isOpen && <div className="absolute right-0 mt-2 w-40 bg-white rounded-xl shadow-xl overflow-hidden z-50 border border-gray-100" data-id="element-425" data-mp="2hl1yu1e2sd4u">
          {languages.map(lang => <button key={lang.code} onClick={() => {
        setLanguage(lang.code);
        setIsOpen(false);
      }} className={`w-full text-left px-4 py-3 text-sm flex items-center space-x-3 hover:bg-card transition-colors ${language === lang.code ? 'bg-card text-navy font-semibold' : 'text-gray-700'}`} data-id="element-426" data-mp="3aasc687vvazw">
              <span className="text-lg" data-id="element-427" data-mp="13m9vb0abn7yn">{lang.flag}</span>
              <span data-id="element-428" data-mp="13kp3vjjb0550">{lang.label}</span>
            </button>)}
        </div>}
    </div>;
};